import React from 'react';
import PopupEditProject from "../../Projects/components/PopupEditProject/PopupEditProject";


export function EditProjectColumnFormatter(id, name, customers) {
  return <PopupEditProject id={id} name={name} customers={customers}/>
}
